<template>
  <vs-popup id="popup"
            title="SUNDRY ORDER INVOICE LIST"
            :active.sync="open"
            :buttons-hidden="true">
    <div class="vx-row mb-3" v-for="document in invoiceDocuments">
      <div class="vx-col md:w-5/6 w-full md:mb-0">
        <small class="label">Name</small>
        <vs-input  readonly :value="document.name" name="name" class="w-full required" label=""/>
      </div>
      <div class="vx-col md:w-1/6 w-full md:mb-0 mt-8">
        <vs-button @click="openInvoiceDocument(document.url)" size="small" color="success" type="filled" icon-pack="feather"
                   icon="icon-eye"/>
      </div>
    </div>
    <div class="flex flex-wrap items-center justify-end mt-8">
      <vs-button @click="addNewInvoice" class="ml-auto mt-2">Add new</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const SundrySupplierRepository = RepositoryFactory.get('sundry')
const InventoryRepository = RepositoryFactory.get('inventory')

export default {
  name: "ViewSundryItemInvoiceListPopUp",
  data(){
    return{
      id:'',
      open:false,
      invoiceDocuments:[]
    }
  },
  methods:{
    async openPopup(id){
      this.id = id
      await this.getSupplierInvoiceDocuments()
      this.open = true
    },
    async getSupplierInvoiceDocuments(){
      this.$vs.loading()
      const {data} = await SundrySupplierRepository.getSundryItemDocuments(this.id)
      this.invoiceDocuments = data.data.filter((invoice) => invoice.type === 'invoice' )
      this.$vs.loading.close()
    },
    async openInvoiceDocument(url){
      window.open(url,'_blank')
    },
    addNewInvoice(){
      this.open = false
      const vue = this
      vue.$parent.openFileUploadPopUp()
    }
  }
}
</script>

<style scoped>

</style>
